@if (isResolving()) {
  <div class="esign-sign-status" [dataSelector]="'cxp-esign-sign-loading'">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else {
  @if (signature(); as resolved) {
    <!--
      The secure-link signing flow, run inside the portal shell. Only the bundle
      differs — everything the signer does here is the flow PP-3761/PP-3764 shipped.
    -->
    <app-esign-signing-container
      [bundleId]="resolved.bundleId"
      [recipientId]="resolved.recipientId"
      [returnTo]="returnTo()"
    ></app-esign-signing-container>
  } @else {
    <div class="esign-sign-status" [dataSelector]="'cxp-esign-sign-unavailable'">
      <p class="esign-sign-message">
        We couldn't open this document for signing. Please go back to your tasks and try again.
      </p>
    </div>
  }
}
